/**
 * Reports Container - Unified reports interface with tabs
 */
import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';

// Import existing report components
import ReportsPage from './ReportsPage';
import CustomReportBuilder from './CustomReportBuilder';
import ScheduledReports from './ScheduledReports';
import TabPanel from '../Common/TabPanel';

const ReportsContainer: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      {/* Page title */}
      <Box sx={{ mb: '20px' }}>
        <Typography sx={{ fontSize: 'var(--text-xl)', fontWeight: 600, color: 'var(--color-text-primary)', fontFamily: 'var(--font-heading)' }}>
          Reports & Analytics
        </Typography>
        <Typography sx={{ fontSize: 'var(--text-base)', color: 'var(--color-text-muted)', mt: 0.5, fontFamily: 'var(--font-body)' }}>
          Generate, customize, and schedule reports for inventory management insights
        </Typography>
      </Box>

      {/* Tab navigation */}
      <Box sx={{ borderBottom: '1px solid var(--color-border)', mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Reports" />
          <Tab label="Custom Reports" />
          <Tab label="Scheduled Reports" />
        </Tabs>
      </Box>

      {/* Tab content */}
      <Box className="page-enter">
        <TabPanel value={tabValue} index={0}>
          <ReportsPage />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <CustomReportBuilder />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <ScheduledReports />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default ReportsContainer;
